import {Component, Injector, NgZone, OnInit} from '@angular/core';
import { CompletedWorksModel, CompletedWorksService } from "../../../services/completedworks.service";
import { ServiceTaskModel, ServiceTaskService } from "../../../services/servicetask.service";
import {DialogBaseComponent} from "../../admin-panel/base-admin-panel/dialog-base/dialog-base.component";
import { ConverterService } from "../../../services/converter.service";

@Component({
    selector: 'app-completed-works-dialog-base',
    templateUrl: './completed-works-dialog-base.component.html',
    styleUrls: ['./completed-works-dialog-base.component.css'],
    standalone: false
})
export class CompletedWorksDialogBaseComponent extends DialogBaseComponent<CompletedWorksModel> implements OnInit
{
  private serviceTaskService: ServiceTaskService;
  private service: CompletedWorksService;
  private converterService: ConverterService;
  private ngZone: NgZone;

  public openedTabName: string = "main";

  constructor(protected injector: Injector) {
    super(injector);
    this.converterService = injector.get(ConverterService);
    this.service = injector.get(CompletedWorksService);
    this.serviceTaskService = injector.get(ServiceTaskService);
    this.ngZone = injector.get(NgZone);
  }

  ngOnInit()
  {
    super.ngOnInit();

    this.serviceTaskService.getAll()
      .subscribe((res) => {
        for (var i = 0; i < res.length; i++)
          if (res[i].ObjectId == this.model.ObjectId)
          {
              for (var j = 0; j < this.model.ServiceTasks.length; j++)
                  if (res[i].Id == this.model.ServiceTasks[j])
                      res[i].IsChecked = true;
              this.objects.push(res[i]);
          }
      });
  }

  public override open(model: any, type: { new(): CompletedWorksModel } = undefined) {
    super.open(model, type);
    this.updateFromJs(model);
  }

  public updateFromJs(data: any) {
    this.ngZone.run(() => {
      this.model = data;
    });
  }

  public submit()
  {
    this.model.ServiceTasks = [];
    for (var i = 0; i < this.objects.length; i++)
      if (this.objects[i].IsChecked)
        this.model.ServiceTasks.push(this.objects[i].Id);

    this.service.update(this.model)
      .subscribe((res) => {
          this.onCreated.emit();
          this.close();
          super.submit();
        });
  }

  public openTab(name: string) {
    this.openedTabName = name;
  }
  public isSelected(name: string) {
    return name == this.openedTabName;
  }

  public onToggleAll(value: boolean) {
    this.objects.forEach((command) => {
      command.IsChecked = value;
    });
  }

  public onToggle(val: any)
  {

  }
  public convertOdometr(value: number)
  {
    this.model.Odometr = this.converterService.ParseKMeters(value);
  }
  public convertEngineTime(value: number)
  {
    this.model.WorkTime = value * 3600000;
  }
  public convertDuration(value: number)
  {
    this.model.Duration = value * 3600000;
  }
}
